import {fontType} from "../constants/font";

export const courses = [
    {
        code: "CTFL",
        type: "ISTQB",
        certificate: "Tester - základná úroveň",
        tags: [
            "Testovanie počas celého životného cyklu softvéru",
            "Statické techniky",
            "Manažment testovania",
            "Dynamické testovacie techniky",
            "Základy testovania",
            "Podporné nástroje testovania",
        ],
        description:
            "Získajte pevné základy a ucelený pohľad na testovanie softvéru s akreditovaným kurzom ISTQB CTFL.<br />" +
            "Naučíte sa, ako efektívne plánovať, navrhovať a vykonávať testy, porozumiete životnému cyklu testovania a osvojíte si medzinárodne uznávané princípy kvality.<br />" +
            "Kurz je ideálny pre nových aj skúsených testerov, ktorí chcú získať systematický rámec a potvrdiť svoje znalosti certifikáciou ISTQB.",
        showPrice: true,
        lectors: [1, 2, 3],
        keywords: [
            'CTFL',
            '4.0',
            'základná',
            'základy',
            'test',
            'štandardné',
            'techniky',
            'statické',
            'dynamické',
            'manažment',
            'podporné',
            'nástroje',
            'začiatočník',
            'prax',
            'štart',
            'certifikát',
            'úroveň',
            'level',
            'stratégia',
            'plán'
        ]
    },
    {
        code: "career-debug",
        type: "ISTQB",
        tags: [],
        description:
            "Nedokážete uspieť či zaujať na pracovnom pohovore? Možno rozhodujú detaily, ktoré vy nevidíte. Zanalyzujme ich, opravme chyby, ktoré bránia poslednému úspešnému kroku k novej kariére.<br />" +
            "Počas školenia vytvoríte profesionálne CV, doladíte LinkedIn profil a natrénujete pohovor tak, aby ste zanechali silný dojem.",
        showPrice: true,
        lectors: [1, 7, 8],
        keywords: [
            'kariéra',
            'príprava',
            'CV',
            'životopis',
            'optimalizácia',
            'technický',
            'pohovor',
            'recruitment',
            'skills',
            'prezentácia',
            'kandidáta',
            'práca',
            'hľadanie',
            'LinkedIn',
            'profil',
            'tester'
        ]
    },
    {
        code: "CTFL-6days",
        type: "ISTQB",
        certificate: "Tester - základná úroveň",
        tags: [
            "Testovanie počas celého životného cyklu softvéru",
            "Statické techniky",
            "Manažment testovania",
            "Dynamické testovacie techniky",
            "Základy testovania",
            "Podporné nástroje testovania",
        ],
        description:
            "Školenie je rozdelené do 6 poldenných celkov so začiatkom v <span style='font-family: "+fontType.semiBold+"'>popracovnom čase</span>.<br />" +
            "<br />" +
            "Získajte pevné základy a ucelený pohľad na testovanie softvéru s akreditovaným kurzom ISTQB CTFL.<br />" +
            "Naučíte sa, ako efektívne plánovať, navrhovať a vykonávať testy, porozumiete životnému cyklu testovania a osvojíte si medzinárodne uznávané princípy kvality.<br />" +
            "Kurz je ideálny pre nových aj skúsených testerov, ktorí chcú získať systematický rámec a potvrdiť svoje znalosti certifikáciou ISTQB.",
        showPrice: true,
        lectors: [1, 2, 3],
        keywords: [
            'CTFL',
            '4.0',
            'základná',
            'základy',
            'test',
            'štandardné',
            'techniky',
            'statické',
            'dynamické',
            'manažment',
            'podporné',
            'nástroje',
            'začiatočník',
            'prax',
            'štart',
            'certifikát',
            'úroveň',
            'level',
            'stratégia',
            'plán'
        ]
    },
    {
        code: "CTAL-TM",
        type: "ISTQB",
        tags: [
            "Testovanie počas celého životného cyklu softvéru",
            "Statické techniky",
            "Manažment testovania",
            "Dynamické testovacie techniky",
            "Základy testovania",
            "Podporné nástroje testovania",
        ],
        certificate: "Test manažér - pokročilá úroveň",
        description:
            "Toto ISTQB školenie, akreditované podľa najnovšej aktualizácie ISTQB® Advanced Level Test Management Syllabus v3.0 pomocou školiacich materiálov spoločnosti Tesena s.r.o. sa zameriava na zručnosti potrebné pri riadení testovania softvéru v rôznych kontextoch životného cyklu a projektov.",
        showPrice: true,
        lectors: [1, 2, 3, 4],
        keywords: [
            'Advanced',
            'analytické',
            'techniky',
            'analýza',
            'dizajn',
            'návrh',
            'rozšírená',
            'teória',
            'praktické',
            'scenáre',
            'design',
            'CTAL',
            'certifikácia',
            'plán',
            'stratéga',
            'prístup',
            'approach',
            'riadenie',
            'manažment',
            'tím',
            'organizácia',
            'koordinácia',
            'riziká',
            'projekt',
            'harmonogram'
        ]
    },
    {
        code: "CTAL-TA",
        type: "ISTQB",
        tags: [
            "Pokročilé aspekty a princípy testovania",
            "Rozšírené techniky testovania",
            "Príprava testovacích podkladov a vytváranie testovacích prípadov",
            "Incident management a reporting",
            "Nástroje pre testovanie a automatizáciu",
            "Etika a štandardy v testovaní",
        ],
        certificate: "Test Analyst - pokročilá úroveň",
        description:
            "Školenie, akreditované podľa najnovšej aktualizácie ISTQB® Advanced Level Test Analyst Syllabus v3.1.1 pomocou školiacich materiálov spoločnosti Tesena s.r.o. sa sústreďuje na hlbšie pochopenie test procesov a začlenenie role test analytika do životného cyklu. Zároveň rozširuje znalosti testovacích techník z foundation level, prináša nové a pokročilejšie techniky v rámci black-box testovania.",
        showPrice: true,
        lectors: [6, 4],
        keywords: [
            'Advanced',
            'analytické',
            'techniky',
            'analýza',
            'dizajn',
            'návrh',
            'rozšírená',
            'teória',
            'praktické',
            'scenáre',
            'design',
            'CTAL',
            'certifikácia'
        ]
    },
    {
        code: "CTAL-TAE",
        type: "ISTQB",
        tags: [
            "Základy automatizácie testovania",
            "Návrh a implementácia automatizácie testovania",
            "Riadenie automatizácie testovania",
            "Pokročilé koncepty automatizácie testovania",
            "Automatizácia testovania v kontexte rôznych paradigiem softvérového vývoja",
            "Praktické príklady a štúdie prípadov",
        ],
        description:
            "Školenie, akreditované podľa najnovšej aktualizácie ISTQB® CT Test Automation Engineer v2.0 pomocou školiacich materiálov spoločnosti Tesena s.r.o. pokrýva dizajn a generickú architektúru riešenia pre test automatizáciu. Prechádza od základných princípov ako vyberať a tvoriť toto riešenie až po spôsob ako pripraviť firmu na jeho zavedenie.",
        certificate: "Test Automation Engineer - pokročilá úroveň",
        showPrice: true,
        lectors: [6, 4],
        keywords: [
            'automatizácia',
            'testovanie',
            'test',
            'automation',
            'engineer',
            'framework',
            'automatizačné',
            'úlohy',
            'scripty',
            'knižnice',
            'automatizované',
            'scenáre',
            'tool',
            'praktiky',
            'princípy',
            'CTAL',
            'certifikácia'
        ]
    },
    {
        code: "test-automation-principles",
        type: "other",
        tags: [
            "Základy automatizácie testovania",
            "Návrh a implementácia automatizácie testovania",
            "Riadenie automatizácie testovania",
            "Pokročilé koncepty automatizácie testovania",
            "Automatizácia testovania v kontexte rôznych paradigiem softvérového vývoja",
            "Praktické príklady a štúdie prípadov",
        ],
        description:
            "Posuňte svoju kariéru testera na vyššiu úroveň. Školenie vás naučí, ako premyslene navrhnúť a zaviesť automatizované testy, vybrať vhodné nástroje a pripraviť tím aj organizáciu na hladký prechod. Akým chybám sa vyhnúť, na čo nezabudnúť. Praktické tipy a osvedčené postupy vám navyše umožnia okamžite nastaviť kvalitu automatizovaných scriptov na potrebnú úroveň a ušetriť čas. Získate know-how, ktoré priamo zvýši efektivitu vašich projektov a uľahčí prácu každému v tíme.",
        showPrice: true,
        lectors: [1],
        process: [],
        keywords: [
            'automatizácia',
            'testovanie',
            'test',
            'automation',
            'engineer',
            'framework',
            'automatizačné',
            'úlohy',
            'scripty',
            'knižnice',
            'automatizované',
            'scenáre',
            'tool',
            'praktiky',
            'princípy',
            'CTAL',
            'certifikácia',
            'pokročilé',
            'CI/CD',
            'skripty',
            'tooling',
            'infra'
        ]
    },
    {
        code: "SCRUM-basics",
        type: "other",
        tags: [
            'Agilný vývoj softvéru',
            'Základné princípy agilného testovania',
            'Postupy a procesy agilného testovania',
            'Agilné testovacie metódy',
            'Agilné techniky a nástroje',
            'SCRUM',
            'SCRUM metodológia',
            'SCRUM master'
        ],
        lectors: [3],
        description:
            "Základný kurz pre účastníkov, ktorí sa snažia SCRUM vo firme implementovať, prípadne ho už používajú. Školenie je vhodné pre členov SCRUM tímov, ale aj pre ľudí z IT mimo SCRUM tímov aj z biznisového prostredia.",
        showPrice: true,
        process: [],
        phrase:
            "Absolvovaním školenia získaš znalosti a osvojíš si princípy agilného testovania a SCRUM metodológie.",
        btnTxt: "Chcem byť platný člen agilného tímu",
        keywords: [
            'agile',
            'testing',
            'test',
            'dizajn',
            'techniky',
            'certifikácia',
            'CTFL',
            'agilný',
            'SCRUM',
            'Kanban',
            'lifecycle',
            'postupy',
            'procesy',
            'metodiky'
        ]
    },
    {
        code: "SCRUM-master",
        type: "other",
        tags: [
            'Agilný vývoj softvéru',
            'Základné princípy agilného testovania',
            'Postupy a procesy agilného testovania',
            'Agilné testovacie metódy',
            'Agilné techniky a nástroje',
            'SCRUM',
            'SCRUM metodológia',
            'SCRUM master'
        ],
        lectors: [3],
        description:
            "Kurz je určený pre všetkých, ktorí si chcú osvojiť základy agilného vývoja metodológiou SCRUM, hlavne pre uchádzačov pracujúcich v roly SCRUM master, prípadne začínajúcich SCRUM mastrov.",
        showPrice: true,
        process: [],
        phrase:
            "Absolvovaním školenia získaš znalosti potrebné pre začínajúceho ale aj skúseného SCRUM mastra, osvojíš si princípy agilného testovania a SCRUM metodológie.",
        btnTxt: "Chcem byť kvalitný SCRUM master",
        keywords: [
            'agile',
            'testing',
            'test',
            'dizajn',
            'techniky',
            'certifikácia',
            'CTFL',
            'agilný',
            'SCRUM',
            'Kanban',
            'lifecycle',
            'postupy',
            'procesy',
            'metodiky',
            'master'
        ]
    },
    {
        code: "J-SW-tester",
        type: "other",
        tags: [
            "Praktické a interaktívne cvičenia",
            "Praktická skúška",
            "Certifikát",
        ],
        lectors: [1],
        description:
            "Tento kurz nadväzuje na CTFL a prenesie vás od teórie do praxe. Naučíte sa, ako tvoriť testovacie scenáre, pripravovať testovacie dáta a vytvárať jasné defect reporty. Vyskúšate si hľadanie chýb v špecifikáciách, v defekt reportoch, otestujete jednoduchú aplikáciu, spoznáte špecifiká testovania webových, mobilných, cloudových aj IoT aplikácií a získate základy práce s nástrojmi ako Jira, SQL či Linux.<br />" +
            "Kurz je určený pre tých, ktorí chcú nadobudnúť <span style='font-family: "+fontType.semiBold+"'>praktické zručnosti pre každodennú prácu testera</span>, ktoré sa do teoretického CTFL nezmestili. Po absolvovaní budete pripravení okamžite testovať na reálnych projektoch.",
        showPrice: true,
        process: [
            {
                header: "Teoretická časť",
                text: "Obsahom je teória, metodika, typy testov, špecifiká testovania, testovacie scenáre, reportovanie bugov, funkčné manuálne testovanie, nástroje v praxi testera, základné príkazy linuxu, práca s VPN, remote pripojenie na Windows/Linux server, Putty, WinSCP, rady ako úspešne zvládnuť pracovný pohovor.",
            },
            {
                header: "Cvičná časť",
                text: "Cvičenia ku školeniu Junior SW tester (manuálne funkčné testovanie v praxi, reportovanie bugov v praxi, práca s bug trackingovým nástrojom JIRA, cvičenie zamerané na SQL SELECT.",
            },
            {
                header: "Praktická časť",
                text: "Zameraná na manuálny funkčný test v praxi, reportovanie bugov a písanie testovacích scenárov v JIRE + záverečný online test. Účastník školenia bude mať 3 dni na vypracovanie praktického zadania (vypracovanie praktického zadania prebieha offline). Následne po vyhodnotení praktického zadania bude vyzvaný k vyplneniu záverečného online testu. Výsledok záverečného online testu má iba informatívny charakter a nemá vplyv na vystavenie certifikátu o absolvovaní školenia.",
            },
        ],
        phrase:
            "Absolvovaním školenia získaš všetky potrebné znalosti na praktický výkon profesie junior SW tester.",
        btnTxt: "Chcem sa stať SW testerom",
        keywords: [
            'technické',
            'testovanie',
            'test',
            'Jira',
            'API',
            'testing',
            'web',
            'tools',
            'databázové',
            'test',
            'nástroje',
            'automatizácia',
            'defekty',
            'report',
            'typy',
            'úrovne',
            'SQL',
            'Linux',
            'špecifikácia',
            'user',
            'praktické',
            'prax',
            'cvičenia',
            'CTFL',
            'príklady',
            'scenáre',
            'prípady',
            'case',
            'tvorba',
            'bug'
        ]
    },
    {
        code: "S-SW-tester",
        type: "other",
        tags: [
            "Praktické a interaktívne cvičenia",
            "Praktická skúška",
            "Certifikát",
        ],
        lectors: [1],
        description:
            "Nadväzujúci kurz pre testerov, ktorí chcú posunúť svoje zručnosti na profesionálnu úroveň. Zameriava sa na pokročilú testovaciu analýzu, návrh testov, prácu s dátami, webové služby, DevOps a testovanie AI. Kurz je silne prakticky orientovaný s množstvom cvičení a reálnych scenárov.",
        showPrice: true,
        process: [
            {
                header: "Teoretická časť",
                text: "Analýza testovania (vstupy, techniky, riziká, prioritizácia testov, automatizácia, ROI), Návrh testov, príprava testovacích údajov (kategórie, syntetické-mock testovacie dáta, generovanie, bezpečnosť, údržba, tipy), Web Developer, Webové služby, Defecty, Testovanie databáz, Manažment testovania.",
            },
            {
                header: "Cvičná časť",
                text: "Cvičenia k školeniu Senior SW tester:<br/><ul><li>Analýza testov</li><li>Návrh testov (tvorba test scenárov a testovacích prípadov)</li><li>Tvorba testovacích dát</li><li>Web developer</li><li>Defecty</li><li>Tvorba test reportu a Test Exit reportu</li></ul>",
                textAlign: 'justify'
            },
            {
                header: "Praktická časť",
                text: "Zameraná na tvorbu testovacích scenárov, testovacích prípadov, priebežného a záverečného test reportu. Účastník školenia bude mať 3 dni na vypracovanie praktického zadania (vypracovanie praktického zadania prebieha offline). Následne po vyhodnotení praktického zadania bude vyzvaný k vyplneniu záverečného online testu. Výsledok záverečného online testu má iba informatívny charakter a nemá vplyv na vystavenie certifikátu o absolvovaní školenia.",
            },
        ],
        phrase:
            "Absolvovaním školenia získaš všetky potrebné znalosti na praktický výkon profesie senior SW tester.",
        btnTxt: "Chcem sa stať SW testerom",
        keywords: [
            'technické',
            'testovanie',
            'test',
            'API',
            'testing',
            'web',
            'tools',
            'databázové',
            'test',
            'nástroje',
            'automatizácia',
            'defekty',
            'report',
            'typy',
            'úrovne',
            'SQL',
            'špecifikácia',
            'user',
            'praktické',
            'prax',
            'cvičenia',
            'CTFL',
            'príklady',
            'analýza',
            'dizajn',
            'návrh',
            'scenáre',
            'prípady',
            'case',
            'tvorba',
            'bug',
            'dáta',
            'údaje',
            'mock',
            'weDeveloper',
            'SOAP',
            'REST',
            'AI',
            'umelá',
            'inteligencia'
        ]
    },
    {
        code: "SQL-basics",
        type: "other",
        tags: [
            "Vlastný Oracle server",
            "Základný syntax",
            "SQL teória",
            "Ako písať selecty",
            "Logické, textové a matematické operátory",
            "Aliasy",
            "Zoradenie pomocou Order By",
            "Spojenie dvoch tabuliek",
            "Joiny",
            "Vnorený select",
            "Praktické cvičenia",
        ],
        lectors: [1],
        description:
            "Získajte pevné základy práce s relačnými databázami a SQL. Kurz vás naučí <span style='font-family: "+fontType.semiBold+"'>čítať a kontrolovať</span> obsah tabuliek vrátane zložitejších JOINov. Taktiež vytvárať, upravovať a odstraňovať dáta v databázach pomocou praktických príkladov a cvičení. Ideálny pre testerov, vývojárov alebo každého, kto chce zvládnuť SQL pre každodennú prácu.",
        showPrice: true,
        process: [
            {
                header: "Trvanie: 1 deň",
                text: "Základy jazyka SQL vďaka ktorému je možné pracovať – komunikovať s databázami. Ukážeme si príklad selectu a naučíš sa samostatne písať základné selecty. Zistíš, ako sa píšu rôzne podmienky pre obmedzenie výberu, ako urobiť výpis krajší a čitateľnejší pre človeka a na záver sa zoznámime s najväčším nepriateľom testera juniora – s JOIN-ami.",
            },
        ],
        phrase:
            "Absolvovaním školenia budeš ovládať základy jazyka SQL pre prácu s databázou.",
        btnTxt: "Chcem sa naučiť základy SQL",
        keywords: [
            'SQL',
            'základy',
            'SELECT',
            'INSERT',
            'UPDATE',
            'DELETE',
            'JOIN',
            'poddodazy',
            'tabuľky',
            'spájanie',
            'databáza',
            'DB',
            'relačná',
            'primárny',
            'cudzí',
            'kľúč'
        ]
    },
    {
        code: "SQL-advanced",
        type: "other",
        tags: [
            "Update záznamov",
            "Mazanie záznamov",
            "Vytvorenie Tabuľky - Create Table",
            "Zmazanie Tabuľky – Drop Table",
            "Vkladanie údajov do Tabuľky – Insert Into",
            "Update záznamov",
            "Kľúče a obmedzenie – SQL Constraints",
            "Zmena Tabuľky – Alter Table",
            "Úvod do číselných funkcií",
            "Úvod do textových funkcií",
            "Úvod do dátumových funkcií",
            "Úvod do konverzných funkcií",
            "Úvod do Xml funkcie",
            "Úvod do analytických funkcií",
            "Praktické cvičenia",
        ],
        lectors: [1],
        description:
            "Rozšírte svoje znalosti SQL a naučte sa efektívne pracovať s komplexnými dotazmi, štruktúrami databáz, transakciami a bezpečnostnými mechanizmami. Naučíte sa databázu nie len využívať ale aj tabuľky vytvárať a spravovať.<br />" +
            "Kurz obsahuje praktické príklady a cvičenia, ktoré pripravia účastníkov na reálne situácie v práci s databázami.",
        showPrice: true,
        process: [
            {
                header: "Trvanie: 2 dni",
                text: "Nadviažeme na výberové dotazy, preberané v školení SQL základy, príkazmi pre úpravu, vkladaním a odstraňovaním záznamov a s tým súvisiacimi transakciami. Po predstavení základných dátových typov sa naučíš vytvárať vlastné relačné tabuľky, pohľady a ďalšie užitočné objekty. V závere školenia sa dozvieš, ako prideliť práva na svoje objekty iným používateľom.",
            },
        ],
        phrase:
            "Absolvovaním školenia získaš potrebné znalosti o SQL databáze a staneš sa profesionálnym testerom.",
        btnTxt: "Chcem sa stať pro testerom",
        keywords: [
            'SQL',
            'základy',
            'SELECT',
            'INSERT',
            'UPDATE',
            'DELETE',
            'JOIN',
            'poddodazy',
            'tabuľky',
            'spájanie',
            'databáza',
            'DB',
            'relačná',
            'primárny',
            'cudzí',
            'kľúč',
            'GROUP',
            'funkcie',
            'DML',
            'DDL',
            'DCL',
            'vytváranie',
            'mazanie',
            'transakcie',
            'index',
            'view',
            'príkazy',
            'ALTER',
            'constraints'
        ]
    },
    {
        code: "internship",
        type: "other",
        tags: [],
        lectors: [],
        description:
            "Získajte prvú reálnu skúsenosť s testovaním priamo v IT prostredí.<br/>" +
            "Počas stáže sa zapojíte do reálnych projektov u klientov, kde si vyskúšate testovacie postupy, komunikáciu s vývojármi aj prácu v tíme.<br/>" +
            "Pod vedením mentorov z AAS Solutions prepojíte teóriu z kurzov s praxou a zistíte, ako vyzerá testovanie „naostro“.<br/>" +
            "Stáž je dostupná pre absolventov AAS Academy, ktorí chcú dostať testovanie do svojho profesného CV a posunúť svoje znalosti o krok ďalej – od certifikátu k reálnym skúsenostiam.",
        showPrice: false,
        isPractice: true,
        process: [],
        phrase:
            "Absolvovaním praktickej stáže získaš finálny certifikát o absolvovaní praxe + potvrdenie o absolvovaní praxe + “odporúčací list” a referencie.",
        btnTxt: "Chcem prax zadarmo",
        keywords: [
            'stáž',
            'reálna',
            'prax',
            'test',
            'projekt',
            'profesionálne',
            'prostredie',
            'aplikácia',
            'zručnosť',
            'klient',
            'tím',
            'práca',
            'uplatnenie',
            'skúsenosti',
            'skúsený'
        ]
    },
    {
        code: "GEN-AI",
        type: "other",
        tags: [],
        lectors: [1],
        description:
          "Praktický kurz zameraný na efektívne využitie generatívnej AI v softvérovom testovaní. Naučíte sa techniky promptovania, hodnotenia výstupov, riadenia rizík a implementácie AI do testovacích procesov. Kurz je ideálny pre testerov, ktorí chcú posunúť svoje schopnosti v testovaní s využitím AI nástrojov.",
        showPrice: true,
        process: [],
        keywords: [
            'LLM',
            'AI',
            'umelá',
            'inteligencia',
            'generatívna',
            'jazykový',
            'model',
            'test',
            'tokenizácia',
            'prompt',
            'rozpoznávanie',
            'techniky',
            'vylepšovanie',
            'stratégia',
            'adopcia',
            'riziká',
            'bias',
            'halucinovanie'
        ]
    },
    {
        code: "test-automation",
        type: "other",
        tags: [],
        lectors: [9],
        description: `Tento 9-týždňový kurz ťa naučí <span style="font-family: `+fontType.semiBold+`">prakticky automatizovať</span> testy pre webové aplikácie aj API pomocou moderných nástrojov, <span style="font-family: `+fontType.semiBold+`">vrátane využitia umelej inteligencie</span>. Získaš skúsenosti na reálnych projektoch, kde si vyskúšaš celý proces – od <span style="font-family: `+fontType.semiBold+`">návrhu</span> až po <span style="font-family: `+fontType.semiBold+`">tvorbu</span> a <span style="font-family: `+fontType.semiBold+`">spúšťanie</span> vlastných testov. Kurz je ideálny pre testerov, junior programátorov či študentov, ktorí chcú zrýchliť svoj kariérny rast a stať sa žiadanými odborníkmi na trhu práce. Ak chceš posunúť svoje testovacie zručnosti na vyšší level, toto školenie je presne pre teba.`,
        showPrice: true,
        process: [],
        keywords: [
            'domain',
            'testovanie',
            'špecifické',
            'scenáre',
            'industry',
            'best',
            'practices',
            'Python',
            'VS',
            'Code',
            'kód',
            'funkcie',
            'GUI',
            'API',
            'GIT',
            'prax',
            'automatizované',
            'scripty',
            'spúšťať',
            'programovanie',
            'AI'
        ]
    },
    {
        code: "learn-programming",
        type: "other",
        tags: [],
        lectors: [9],
        description: `Tento 6-týždňový kurz ti dá pevné základy <span style="font-family: `+fontType.semiBold+`">programovania v Pythone</span> a naučí ťa myslieť ako programátor – rozkladať problémy, tvoriť riešenia a <span style="font-family: `+fontType.semiBold+`">písať čistý, zrozumiteľný kód</span>. V prakticky zameraných lekciách si vytvoríš vlastné mini-projekty, naučíš sa pracovať s modernými nástrojmi aj AI asistentmi a získaš certifikát vhodný na zdieľanie napríklad na LinkedIne. Kurz je ideálny pre začiatočníkov, budúcich testerov či kohokoľvek, kto chce rýchlo pochopiť základy programovania. Ak chceš odštartovať svoju technickú kariéru alebo si otvoriť cestu k automatizácii testov, toto je ten správny štart.`,
        showPrice: true,
        process: [],
        keywords: [
            'domain',
            'testovanie',
            'špecifické',
            'scenáre',
            'industry',
            'best',
            'practices',
            'Playwright',
            'Robot',
            'Framework',
            'GUI',
            'API',
            'GIT',
            'prax',
            'automatizované',
            'scripty',
            'spúšťať',
            'programovanie',
            'program',
            'algoritmus',
            'projekt',
            'inštalácia',
            'premenné',
            'AI'
        ]
    }
];
